import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCategories } from "../../contexts/CategoryContext";
import {
  FaChevronUp,
  FaChevronDown,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import capitalizeFirst from "../../utils/capitalizeFirst";
import styles from "../../styles/components/layout/Footer.module.css";

function Footer() {
  const { categories } = useCategories();
  const [openSections, setOpenSections] = useState({
    categories: false,
    company: false,
  });

  // Toggle mobile accordion sections
  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // Get top 8 categories
  const topCategories = categories.slice(0, 8);

  return (
    <footer className={styles.siteFooter}>
      <div className={styles.footerContent}>
        {/* Column 1: Brand & Description */}
        <div className={styles.footerColumn}>
          <h3 className={styles.footerLogo}>Simpary</h3>
          <p className={styles.footerTagline}>
            Smart choice for electronics comparison.
          </p>
          <div className={styles.footerSocial}>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Twitter"
            >
              <FaTwitter />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on LinkedIn"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Instagram"
            >
              <FaInstagram />
            </a>
          </div>
          <p className={styles.footerDescription}>
            Whether you want instant AI recommendations tailored to your needs,
            detailed side-by-side comparisons to make informed choices, or
            prefer browsing our extensive catalog freely—we've got you covered.
            Multiple paths to confident product decisions in minutes, not hours,
            with expert reviews, community insights, and smart filtering to help
            you find exactly what you're looking for.
          </p>
        </div>

        {/* Column 2: Product Categories */}
        <div className={styles.footerColumn}>
          <h4
            className={styles.columnTitle}
            onClick={() => toggleSection("categories")}
          >
            Categories
            <span className={styles.mobileToggle}>
              {openSections.categories ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </h4>
          <nav
            className={`${styles.footerLinks} ${openSections.categories ? styles.open : ""}`}
            aria-label="Product categories"
          >
            {topCategories.length > 0 ? (
              <>
                {topCategories.map((cat) => (
                  <Link
                    key={cat._id}
                    to={`/category/${encodeURIComponent(cat._id)}`}
                  >
                    {capitalizeFirst(cat.name)}
                  </Link>
                ))}
                {categories.length > 8 && (
                  <Link to="/" className={styles.viewAll}>
                    Home →
                  </Link>
                )}
              </>
            ) : (
              <span className={styles.loadingText}>Loading categories...</span>
            )}
          </nav>
        </div>

        {/* Column 3: Company & Legal */}
        <div className={styles.footerColumn}>
          <h4
            className={styles.columnTitle}
            onClick={() => toggleSection("company")}
          >
            Company
            <span className={styles.mobileToggle}>
              {openSections.company ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </h4>
          <nav
            className={`${styles.footerLinks} ${openSections.company ? styles.open : ""}`}
            aria-label="Company information"
          >
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </nav>
        </div>
      </div>

      {/* Bottom Section */}
      <div className={styles.footerBottom}>
        <div className={styles.footerBottomContent}>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} Simpary. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
